export const WEEKDAYS_SHORT = ["N", "P", "U", "S", "Č", "P", "S"];
export const WEEKDAYS_LONG = [
    "Nedjelja",
    "Ponedjeljak",
    "Utorak",
    "Srijeda",
    "Četvrtak",
    "Petak",
    "Subota",
];